module.exports = __webpack_public_path__ + "static/media/icon-next.210e3b95.svg";